import { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import s from './Popup.module.css';
import { lockBodyScroll, unlockBodyScroll } from '@/lib/helpers';
import Image from 'next/image';
import useIsMobile from '@/hooks/use-is-mobile';

interface PopupProps {
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ onClose }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    lockBodyScroll();
    return () => {
      unlockBodyScroll();
    };
  }, []);

  const isMobile = useIsMobile();

  // para cerrar con ESC o click fuera del bg

  // const handleOutsideClick = (event: MouseEvent) => {
  //   if (contentRef.current && !contentRef.current.contains(event.target as Node)) {
  //     onClose();
  //   }
  // };

  // const handleEscapeKey = (event: KeyboardEvent) => {
  //   if (event.key === 'Escape') {
  //     onClose();
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener('mousedown', handleOutsideClick);
  //   document.addEventListener('keydown', handleEscapeKey);

  //   return () => {
  //     document.removeEventListener('mousedown', handleOutsideClick);
  //     document.removeEventListener('keydown', handleEscapeKey);
  //   };
  // }, [onClose]);

  const handleClose = () => {
    onClose();
  };

  return (
    <AnimatePresence>
      <motion.div
        className={s.bg}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}>
        <motion.div
          className={s.bg__pop_up}
          ref={contentRef}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}>
          <button className={s.bg__pop_up__close} onClick={handleClose}>
            <Image src="/images/close.svg" alt="Cerrar" width={20} height={20} />
          </button>
          <div className={s.bg__pop_up__info}>
            <div className={s.bg__pop_up__info__banner}>
              <Image
                className={s.bg__pop_up__info__banner__img}
                src="/images/buenfin.png"
                alt="Buen Fin"
                width={83}
                height={83}
              />
              <span className={s.bg__pop_up__info__banner__text}>
                OPORTUNIDAD ÚNICA ESTE BUEN FIN
              </span>
            </div>
            <div className={s.bg__pop_up__info__texts}>
              <h2 className={s.bg__pop_up__info__texts__pretitle}>Aparta tu lote y obtén un</h2>
              <h1 className={s.bg__pop_up__info__texts__title}>
                20% <br />
                DE DESCUENTO
              </h1>
              <h3 className={s.bg__pop_up__info__texts__subtitle}>
                Consulta planes de financiamiento participantes.
              </h3>

              {isMobile && (
                <Image
                  className={s.bg__pop_up__img}
                  src="/images/img-popup-mobile.jpg"
                  alt="Descuento"
                  width={450}
                  height={450}
                />
              )}

              <p className={s.bg__pop_up__info__texts__description}>
                Participan todos los planes de pago que tienen la modalidad de financiamiento con
                15% de descuento. Del 15 al 18 de noviembre se aplicará el 20% de descuento en lugar
                del 15%.
              </p>
            </div>
          </div>

          {!isMobile && (
            <Image
              className={s.bg__pop_up__img}
              src="/images/img-popup-mobile.jpg"
              alt="Descuento"
              width={450}
              height={450}
            />
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Popup;
